// Aeteria: header turns #FAFAF7 once the page has scrolled 40px.
// Horizon scrolls inside .page-wrapper rather than the window, so listen to both.
(() => {
  const header = document.getElementById('header-component');
  if (!header) return;

  const scroller = document.querySelector('.page-wrapper');
  const offset = () => Math.max(window.scrollY, scroller ? scroller.scrollTop : 0);
  const update = () => header.toggleAttribute('data-aet-scrolled', offset() > 40);

  update();
  window.addEventListener('scroll', update, { passive: true });
  scroller?.addEventListener('scroll', update, { passive: true });
})();

// Aeteria: mark the current page on the mobile menu's secondary links (Sizing, Care, Contact),
// so they get the same current-page underline as the main links. Horizon re-renders the header
// after load and resets attributes, so the mark is re-applied whenever the header changes.
(() => {
  const mark = () => {
    document.querySelectorAll('.aet-drawer-secondary__link:not([aria-current])').forEach((link) => {
      if (link.pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
    });
  };

  mark();
  const header = document.getElementById('header-component');
  if (header) {
    new MutationObserver(mark).observe(header, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });
  }
})();

// Aeteria: "Select a size" stays clickable. With no size chosen, a press sends the shopper to the size picker
// instead of adding the first size. Runs in the capture phase so Horizon's add-to-cart handlers never see it.
const clearNeedsSize = () => document.querySelectorAll('[data-needs-size]').forEach((el) => el.removeAttribute('data-needs-size'));

document.addEventListener('change', (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('variant-picker')) return;
  clearNeedsSize();
  window.setTimeout(clearNeedsSize, 1500);
});

document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-needs-size]') : null;
    if (!button) return;

    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    // A size is chosen: the flag is stale (Horizon updates the page in place), so let the add go through.
    if (picker.querySelector('input[type="radio"]:checked')) {
      clearNeedsSize();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    picker.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
    picker.querySelector('input[type="radio"]:not(:disabled)')?.focus({ preventScroll: true });
    picker.setAttribute('data-aet-needs-size', '');
    window.setTimeout(() => picker.removeAttribute('data-aet-needs-size'), 1600);
  },
  true
);
